<template>
    <div class="task_page-new lkt-answer" id="task_answer">
        <div class="task_main" ref="middle_page">
            <div class="taskPage">
                <div class="taskPage_task taskPage_task_edit">
                    <div class="taskContent_main">
                        <div class="task-flex">
                            <div class="task_content">
                                <div
                                    class="fix-img-h line-height"
                                    v-html="data.questionContent"
                                ></div>
                                <!-- <template v-if="checkVN==4">
                                    <template v-if="isCheckDD==true">
                                        <audio
                                            v-if="
                                                data.audioName != undefined &&
                                                data.audioName != null &&
                                                data.audioName != '' &&
                                                'mp3' == data.audioName.substring(data.audioName.lastIndexOf('.') + 1)
                                            "
                                            controls="controls"
                                            :src="'https://www.studyarts.vn/file/'+data.audioPath"
                                            controlslist="nodownload"
                                            oncontextmenu=" return false"
                                            class="audio"
                                        ></audio>
                                        <video
                                            v-if="
                                                data.audioName != undefined &&
                                                data.audioName != null &&
                                                data.audioName != '' &&
                                                'mp4' == data.audioName.substring(data.audioName.lastIndexOf('.') + 1)
                                            "
                                            :src="'https://www.studyarts.vn/file/'+data.audioPath"
                                            controls="controls"
                                            class="video"
                                            controlsList="nodownload"
                                        ></video>
                                    </template>
                                    <template v-else>
                                        <audio
                                            v-if="
                                                data.audioName != undefined &&
                                                data.audioName != null &&
                                                data.audioName != '' &&
                                                'mp3' == data.audioName.substring(data.audioName.lastIndexOf('.') + 1)
                                            "
                                            controls="controls"
                                            :src="'https://www.study-arts.vn/file/'+data.audioPath"
                                            controlslist="nodownload"
                                            oncontextmenu=" return false"
                                            class="audio"
                                        ></audio>
                                        <video
                                            v-if="
                                                data.audioName != undefined &&
                                                data.audioName != null &&
                                                data.audioName != '' &&
                                                'mp4' == data.audioName.substring(data.audioName.lastIndexOf('.') + 1)
                                            "
                                            :src="'https://www.study-arts.vn/file/'+data.audioPath"
                                            controls="controls"
                                            class="video"
                                            controlsList="nodownload"
                                        ></video>
                                    </template>
                                </template> -->
                                <template>
                                    <audio
                                        v-if="
                                            data.audioName != undefined &&
                                            data.audioName != null &&
                                            data.audioName != '' &&
                                            'mp3' == data.audioName.substring(data.audioName.lastIndexOf('.') + 1)
                                        "
                                        controls="controls"
                                        :src="'/file/' + data.audioPath"
                                        controlslist="nodownload"
                                        oncontextmenu=" return false"
                                        class="audio"
                                    ></audio>
                                    <video
                                        v-if="
                                            data.audioName != undefined &&
                                            data.audioName != null &&
                                            data.audioName != '' &&
                                            'mp4' == data.audioName.substring(data.audioName.lastIndexOf('.') + 1)
                                        "
                                        :src="data.audioPath"
                                        controls="controls"
                                        class="video"
                                        controlsList="nodownload"
                                    ></video>
                                </template>
                            </div>
                            <div class="tast-right" v-if="data.questionTypeId == '1'">
                                <div class="task_answer_radio">
                                    <p v-if="data.optionA">
                                        <input v-model="radioValue"
                                            id="radio_a"
                                            type="radio"
                                            name="radio"
                                            value="A"
                                            disabled
                                        />
                                        <label for="radio_a">
                                            <span>A.</span>
                                            <span class="nmjs line-height" v-html="data.optionA"></span>
                                        </label>
                                    </p>
                                    <p v-if="data.optionB">
                                        <input v-model="radioValue"
                                            id="radio_b"
                                            type="radio"
                                            name="radio"
                                            value="B"
                                            disabled
                                        />
                                        <label for="radio_b">
                                            <span>B.</span>
                                            <span class="nmjs line-height" v-html="data.optionB"></span>
                                        </label>
                                    </p>
                                    <p v-if="data.optionC">
                                        <input v-model="radioValue"
                                            id="radio_c"
                                            type="radio"
                                            name="radio"
                                            value="C"
                                            disabled
                                        />
                                        <label for="radio_c">
                                            <span>C.</span>
                                            <span class="nmjs line-height" v-html="data.optionC"></span>
                                        </label>
                                    </p>
                                    <p v-if="data.optionD">
                                        <input v-model="radioValue"
                                            id="radio_d"
                                            type="radio"
                                            name="radio"
                                            value="D"
                                            disabled
                                        />
                                        <label for="radio_d">
                                            <span>D.</span>
                                            <span class="nmjs line-height" v-html="data.optionD"></span>
                                        </label>
                                    </p>
                                    <p v-if="data.optionE">
                                        <input v-model="radioValue"
                                            id="radio_e"
                                            type="radio"
                                            name="radio"
                                            value="E"
                                            disabled
                                        />
                                        <label for="radio_e">
                                            <span>E.</span>
                                            <span class="nmjs line-height" v-html="data.optionE"></span>
                                        </label>
                                    </p>
                                    <p v-if="data.optionF">
                                        <input v-model="radioValue"
                                            id="radio_f"
                                            type="radio"
                                            name="radio"
                                            value="F"
                                            disabled
                                        />
                                        <label for="radio_f">
                                            <span>F.</span>
                                            <span class="nmjs line-height" v-html="data.optionF"></span>
                                        </label>
                                    </p>
                                    <p v-if="data.optionG">
                                        <input v-model="radioValue"
                                            id="radio_g"
                                            type="radio"
                                            name="radio"
                                            value="G"
                                            disabled
                                        />
                                        <label for="radio_g">
                                            <span>G.</span>
                                            <span class="nmjs line-height" v-html="data.optionG"></span>
                                        </label>
                                    </p>
                                    <p v-if="data.optionH">
                                        <input v-model="radioValue"
                                            id="radio_h"
                                            type="radio"
                                            name="radio"
                                            value="H"
                                            disabled
                                        />
                                        <label for="radio_h">
                                            <span>H.</span>
                                            <span class="nmjs line-height" v-html="data.optionH"></span>
                                        </label>
                                    </p>
                                    <p v-if="data.optionI">
                                        <input v-model="radioValue"
                                            id="radio_i"
                                            type="radio"
                                            name="radio"
                                            value="I"
                                            disabled
                                        />
                                        <label for="radio_i">
                                            <span>I.</span>
                                            <span class="nmjs line-height" v-html="data.optionI"></span>
                                        </label>
                                    </p>
                                    <p v-if="data.optionJ">
                                        <input v-model="radioValue"
                                            id="radio_j"
                                            type="radio"
                                            name="radio"
                                            value="J"
                                            disabled
                                        />
                                        <label for="radio_j">
                                            <span>J.</span>
                                            <span class="nmjs line-height" v-html="data.optionJ"></span>
                                        </label>
                                    </p>
                                </div>
                            </div>
                            <div class="tast-right" v-if="data.questionTypeId == '2'">
                                <div class="task_answer_radio task_answer_checkbox">
                                <p v-if="data.optionA">
                                    <input class="ip-check"
                                        v-model="checkedValue"
                                        id="checkbox_a"
                                        type="checkbox"
                                        value="A"
                                        disabled
                                    />
                                    <label for="checkbox_a">
                                        <span>A.</span>
                                        <span class="nmjs line-height" v-html="data.optionA"></span>
                                    </label>
                                </p>
                                <p v-if="data.optionB">
                                    <input class="ip-check"
                                        v-model="checkedValue"
                                        id="checkbox_b"
                                        type="checkbox"
                                        value="B"
                                        disabled
                                    />
                                    <label for="checkbox_b">
                                        <span>B.</span>
                                        <span class="nmjs line-height" v-html="data.optionB"></span>
                                    </label>
                                </p>
                                <p v-if="data.optionC">
                                    <input class="ip-check"
                                        v-model="checkedValue"
                                        id="checkbox_c"
                                        type="checkbox"
                                        value="C"
                                        disabled
                                    />
                                    <label for="checkbox_c">
                                        <span>C.</span>
                                        <span class="nmjs line-height" v-html="data.optionC"></span>
                                    </label>
                                </p>
                                <p v-if="data.optionD">
                                    <input class="ip-check"
                                        v-model="checkedValue"
                                        id="checkbox_d"
                                        type="checkbox"
                                        value="D"
                                        disabled
                                    />
                                    <label for="checkbox_d">
                                        <span>D.</span>
                                        <span class="nmjs line-height" v-html="data.optionD"></span>
                                    </label>
                                </p>
                                <p v-if="data.optionE">
                                    <input class="ip-check"
                                        v-model="checkedValue"
                                        id="checkbox_e"
                                        type="checkbox"
                                        value="E"
                                        disabled
                                    />
                                    <label for="checkbox_e">
                                        <span>E.</span>
                                        <span class="nmjs line-height" v-html="data.optionE"></span>
                                    </label>
                                </p>
                                <p v-if="data.optionF">
                                    <input class="ip-check"
                                        v-model="checkedValue"
                                        id="checkbox_f"
                                        type="checkbox"
                                        value="F"
                                        disabled
                                    />
                                    <label for="checkbox_f">
                                        <span>F.</span>
                                        <span class="nmjs line-height" v-html="data.optionF"></span>
                                    </label>
                                </p>
                                <p v-if="data.optionG">
                                    <input class="ip-check"
                                        v-model="checkedValue"
                                        id="checkbox_g"
                                        type="checkbox"
                                        value="G"
                                        disabled
                                    />
                                    <label for="checkbox_g">
                                        <span>G.</span>
                                        <span class="nmjs line-height" v-html="data.optionG"></span>
                                    </label>
                                </p>
                                <p v-if="data.optionH">
                                    <input class="ip-check"
                                        v-model="checkedValue"
                                        id="checkbox_h"
                                        type="checkbox"
                                        value="H"
                                        disabled
                                    />
                                    <label for="checkbox_h">
                                        <span>H.</span>
                                        <span class="nmjs line-height" v-html="data.optionH"></span>
                                    </label>
                                </p>
                                <p v-if="data.optionI">
                                    <input class="ip-check"
                                        v-model="checkedValue"
                                        id="checkbox_i"
                                        type="checkbox"
                                        value="I"
                                        disabled
                                    />
                                    <label for="checkbox_i">
                                        <span>I.</span>
                                        <span class="nmjs line-height" v-html="data.optionI"></span>
                                    </label>
                                </p>
                                <p v-if="data.optionJ">
                                    <input class="ip-check"
                                        v-model="checkedValue"
                                        id="checkbox_j"
                                        type="checkbox"
                                        value="J"
                                        disabled
                                    />
                                    <label for="checkbox_j">
                                        <span>J.</span>
                                        <span class="nmjs line-height" v-html="data.optionJ"></span>
                                    </label>
                                </p>
                                </div>
                            </div>
                            <!-- Loại viết câu trả lời -->
                            <div class="tast-right tast-chat" v-if="data.questionTypeId == '3'">
                                <div class="task_answer_text">
                                <textarea
                                    name
                                    :placeholder="$t('errorBook.answerInput')"
                                    v-model="textAnswer"
                                    disabled
                                ></textarea>
                                </div>
                            </div>
                            <!-- Loại nhiều câu hỏi -->
                            <div class="tast-right" v-if="data.questionTypeId == '4'">
                                <template v-for="(item, index) in data.subQuestionList">
                                  <div class="nhts223" :class="{flxs: item.questionContent == null}" :key="index">

                                    <p class="nhts223-pp-p line-height" v-if="item.questionContent == null">{{index + 1}}.&nbsp;</p>
                                    <span class="line-height" v-html="item.questionContent" v-if="item.questionContent != null"></span>

                                    <div class="task_answer_radio nhts-he">
                                        <span v-if="item.optionA" class="ml-dh-auto" :class="{mb: mobile}">
                                            <input disabled v-model="item.questionAnswer" :id="'radio_s_a_' + index" type="radio" value="A"/>
                                            <label :for="'radio_s_a_' + index">
                                                <span>A.</span>
                                                <span class="nmjs line-height" v-html="item.optionA"></span>
                                            </label>
                                        </span>
                                        <span v-if="item.optionB" class="ml-dh-auto" :class="{mb: mobile}">
                                            <input disabled v-model="item.questionAnswer" :id="'radio_s_b_' + index" type="radio" value="B"/>
                                            <label :for="'radio_s_b_' + index">
                                                <span>B.</span>
                                                <span class="nmjs line-height" v-html="item.optionB"></span>
                                            </label>
                                        </span>
                                        <span v-if="item.optionC" class="ml-dh-auto ms34" :class="{mb: mobile}">
                                            <input disabled v-model="item.questionAnswer" :id="'radio_s_c_' + index" type="radio" value="C"/>
                                            <label :for="'radio_s_c_' + index">
                                                <span>C.</span>
                                                <span class="nmjs line-height" v-html="item.optionC"></span>
                                            </label>
                                        </span>
                                        <span v-if="item.optionD" class="ml-dh-auto ms34" :class="{mb: mobile}">
                                            <input disabled v-model="item.questionAnswer" :id="'radio_s_d_' + index" type="radio" value="D"/>
                                            <label :for="'radio_s_d_' + index">
                                                <span>D.</span>
                                                <span class="nmjs line-height" v-html="item.optionD"></span>
                                            </label>
                                        </span>
                                    </div>
                                  </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            activeItem: null,
            isQuestionPreview: true,
            radioValue: null,
            checkedValue: [],
            textAnswer: null,
            checkVN: 0,
            isCheckDD: false,
        };
    },
    props: {
        data: {}
    },
    computed: {
        mobile() {
            return this.$store.getters["header/mobile"];
        },
    },
    updated () {},
    watch: {},
    mounted() {
        this.checkVN = this.checkGeneralEnvironment();
        this.isCheckDD = this.checkGeneralEnvironmentDongDu();
        this.radioValue = this.data.questionAnswer;
        if(this.data.questionAnswer != null){
            this.checkedValue = this.data.questionAnswer.toString().split(",");
        }
        let textQuestionAnswer = this.data.questionAnswer;
        this.textAnswer = $(textQuestionAnswer).text();
    },
    methods: {
        checkTab: function (name, str) {
            let question = "";

            if (name != null && str != null && str != "") {
                let tag = this.findTagInString(str);
                question = `<${tag.tagName} style="${tag.style || ""}">${name + ".&nbsp;"}</${tag.tagName}><div class="html__custom">${str.replace(/&nbsp;/g, "")}</div>`;
            }

            if (name == null && str != null && str != "") {
                question = str.replace(/&nbsp;/g, '');
            }

            return question;
        },
    }
};
</script>
<style scoped="scoped">
.nhts223-pp-p {
    font-size: 18px;
    margin-top: 5px;
}

.line-height {
    line-height: 36px;
    margin-top: -6px;
}
.nmjs {
    display: inline-flex;
}
.task_main {
  background-color: rgba(65, 65, 65, 0.5);
  width: 100%;
  height: 100%;
  padding-bottom: 50px;
  min-height: calc(100vh - 50px);
}

.taskPage {
  width: 80%;
  margin: 0 auto;
  padding-top: 60px;
  padding-bottom: 50px;
  position: relative;
}

.taskPage_task {
  min-width: 600px;
  width: 60%;
  margin: 0 auto;
  margin-top: 40px;
  padding-bottom: 40px;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 20px 20px 0px 0px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
}

.taskContent_main {
  margin-top: 20px;
  padding: 0 100px;
  font-size: 14px;
  text-align: left;
  word-wrap: break-word;
}

.taskContent_main .task_content {
  line-height: 20px;
  font-size: 14px;
  font-family: lato, sans-serif;
  font-weight: 300;
  font-style: normal;
  text-align: justify;
}

.taskContent_main .task_content p {
  width: 100%;
}

.task_answer_radio {
  margin-top: 20px;
}

.task_answer_radio p {
  width: calc(100% - 40px);
  line-height: 20px;
  font-size: 14px;
  color: #e8e6e6;
  margin-top: 15px;
  display: -webkit-box;
  font-family: lato, sans-serif;
  font-weight: 300;
  font-style: normal;
  text-align: justify;
}

/* .task_answer_radio p label {
  display: -webkit-box;
} */

.task_answer_radio p span {
  cursor: pointer;
}

.task_answer_radio input {
  height: 13px;
  margin-right: 10px;
  margin-top: 5px;
}

.task_answer_text {
  margin-top: 20px;
  width: calc(100% - 40px);
  padding: 2px;
  padding-left: 3px;
  padding-right: 3px;
  background-color: #585858;
  border-radius: 20px;
}
.task_answer_text:focus {
  border: 1px #ff5252 solid !important;
}

.task_answer_text textarea {
  margin-top: 2px;
  margin-right: 1px;
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  height: 160px;
  line-height: 20px;
  background-color: #fff;
  border-radius: 20px;
  font-size: 14px;
  color: #0f0f0f;
  text-align: left;
  border: 0;
  outline: none;
  padding-left: 8px;
  padding-right: 8px;
}
.task_answer_text textarea:focus {
  color: #363030;
}

.task_answer_text textarea::-webkit-input-placeholder {
  color: #e8e6e6;
}

.task_answer_text textarea::-moz-placeholder {
  color: #e8e6e6;
}

.task_answer_text textarea:-moz-placeholder {
  color: #e8e6e6;
}

.task_answer_text textarea:-ms-input-placeholder {
  color: #e8e6e6;
}

.taskPage_task_edit {
  min-height: 500px;
  position: relative;
}

.right_span {
  float: right;
}

@media screen and (max-width: 1024px) {
  .taskPage {
    width: 94%;
    padding: 3%;
  }
  .taskPage_task_edit {
    width: 94%;
    margin: 0 3%;
    min-width: unset;
  }
  .taskPage_task_b {
    width: 94%;
    margin: 0 3%;
    min-width: unset;
  }
  .taskContent_main {
    padding: 0 50px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/manage/previewQuestion.vue